import React from 'react';
import { IconTimeBold, Text } from '@croquiscom-pvt/zds';
import styled from '@emotion/styled';

import { FLOATING_PROMOTION_BANNER_IMAGES } from '../constants/images';

interface FloatingPromotionBannerProps {
  countdown: string;
  priceChangeText: string;
  pointColor: string;
}

export const FloatingPromotionBanner: React.FC<FloatingPromotionBannerProps> = ({
  countdown,
  priceChangeText,
  pointColor,
}) => {
  const isHmsCountdown = /(?<!\d)\d{2}:\d{2}:\d{2}(?!\d)/.test(countdown);
  const isDaysCountdown = /^\d+일$/.test(countdown);
  const shouldShowCountdownSuffix = isHmsCountdown || isDaysCountdown;

  return (
    <Container style={{ backgroundColor: pointColor }}>
      <ContentWrapper>
        <Text variant='Body_14_Multiline_Medium' color='textStrongInverse'>
          특가 종료 시{' '}
          <Text variant='Body_14_Multiline_Bold' color='textStrongInverse' as='span'>
            {priceChangeText}
          </Text>
        </Text>
        <StyledImage src={FLOATING_PROMOTION_BANNER_IMAGES.ARROW_UP} alt='위 화살표' />
      </ContentWrapper>
      {Boolean(countdown) && (
        <TimeWrapper>
          <IconTimeBold size={20} color='iconStrongInverse' style={{ marginRight: '2px' }} />
          <Text
            variant='Body_14_Multiline_Medium'
            color='textStrongInverse'
            style={{ width: isHmsCountdown ? '59px' : undefined }}
          >
            {countdown}
          </Text>
          {shouldShowCountdownSuffix && (
            <Text variant='Body_14_Multiline_Medium' color='textStrongInverse' style={{ whiteSpace: 'break-spaces' }}>
              {' '}
              남음
            </Text>
          )}
        </TimeWrapper>
      )}
    </Container>
  );
};

const Container = styled.div`
  padding: 0 16px;
  width: 100%;
  height: 39px;
  display: flex;
  align-items: center;
  justify-content: space-between;
`;

const ContentWrapper = styled.div`
  display: flex;
  align-items: center;
`;

const StyledImage = styled.img`
  width: 20px;
  height: 20px;
  object-fit: cover;
`;

const TimeWrapper = styled.div`
  display: flex;
  align-items: center;
`;
